module.exports = __webpack_public_path__ + "media/assets/images/blog/Depositphotos_174354892_S-small-c19a887429805670a39807e9ba1e03b9.jpg";